// libraries
import React, { useState, useEffect, useContext } from "react";
import { DatePicker } from "antd";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

import { toast } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// assets
import recentlyViewed from "src/assets/images/home/recently_viewed.svg";
import CheckCircleIcon from "src/assets/icons/check-search.svg";
// import date from "../../../assets/images/home/date.svg";
import close from "src/assets/images/home/close.svg";
// import trending from "../../../assets/images/home/trending.svg";
// import city from "../../../assets/images/home/city.svg";

// icons
import { SearchIcon, ChevronDownIcon } from "src/assets/icons";

// components
import RecentlyViewed from "./RecentlyViewed/RecentlyViewed";
import DropDown from "./DropDown/Dropdown";

// utils
import { keys } from "src/utils/keys";

// context
import UserContext from "src/context/User";

// api
import { clearCache } from "../../utils/cacheApi";

const Form = ({ setShowForm }) => {
  // context
  const { user, userLocation, updateUserLocation } = useContext(UserContext);

  // states
  const [showDD, setShowDD] = useState(false);
  const [show, setShow] = useState(false);

  const [value, setValue] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [location, setLocation] = useState(null);

  // listen to outside on click
  useEffect(() => {
    document.addEventListener("click", () => setShowDD(false));

    return () => {
      document.removeEventListener("click", () => setShowDD(false));
    };
  }, []);

  useEffect(() => {
    if (value) {
      if (showDD) setShowDD(false);
    }
  }, [value, showDD]);

  useEffect(() => {
    if (selectedValue !== null && selectedValue !== "") {
      geocodeByPlaceId(selectedValue.value.place_id)
        .then((res) => {
          let lat = res[0].geometry.location.lat();
          let lng = res[0].geometry.location.lng();

          setLocation({
            lat,
            lng,
            city:
              res[0].address_components[0].long_name ||
              selectedValue.label.split(",")[0],
          });
        })
        .catch((err) => console);
    }
  }, [selectedValue]);

  const handleEventClick = (e) => {
    setShowDD(true);

    document.querySelector(".css-2b097c-container input").focus();
    e.stopPropagation();
  };

  const handleCityClick = (_city) => {
    setValue(_city.city);
    setLocation({
      lat: _city.lat,
      lng: _city.lng,
      city: _city.city,
    });
  };

  const updateLocation = () => {
    if (location) {
      clearCache();

      updateUserLocation(location.lat, location.lng, location.city, false);

      let check = setShowForm || null;

      if (check) {
        closeForm();
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
      }
    } else {
      toast.info("field empty");
    }
  };

  const closeForm = () => {
    setShowForm(false);
    document.body.classList.remove("set-y");
  };

  console.log({ value, selectedValue });

  return (
    <div className={`${styles.form}`}>
      <img
        src={close}
        alt="close"
        className={styles.close}
        onClick={closeForm}
      />
      <div className={styles.body}>
        <div className={styles.input}>
          <div className={`form-input-wrapper ${styles.wrapper}`}>
            <h3>Welcome back!</h3>
            <p>
              you now searching {userLocation?.city || user?.location?.city}
            </p>
            <div className={styles.search__wrapper}>
              {!showDD && (
                <div className={styles.helper} onClick={handleEventClick} />
              )}
              <div className={styles.action__wrapper}>
                <div className={styles.advance}>
                  <span>Adavnce</span>
                  <ChevronDownIcon />
                </div>
                <span className={styles.searchBtn} onClick={updateLocation}>
                  <SearchIcon />
                </span>
              </div>
              <GooglePlacesAutocomplete
                apiKey={keys.google_api_key}
                selectProps={{
                  selectValue: selectedValue,
                  onChange: setSelectedValue,
                  onInputChange: setValue,
                  openMenuOnClick: false,
                  inputValue: value,
                  placeholder: "Search anything",
                }}
                autocompletionRequest={{
                  types: ["(cities)"],
                  componentRestrictions: { country: "us" },
                }}
              />
              <DropDown visible={showDD} handleCityClick={handleCityClick} />
            </div>
          </div>
        </div>
        {/* <div className={styles.date}>
          <div style={{ position: "relative" }}>
            <Input
              label="Start Date"
              type="text"
              value={formData.start_date}
              icon={<img src={date} alt="starting" />}
              style={{ color: "#165FFC" }}
              readOnly
            />
            <div className={styles.picker__wrapper}>
              <DatePicker
                placeholder=""
                inputReadOnly
                bordered={false}
                value=""
                onChange={(_date) => {
                  setFormData({
                    ...formData,
                    start_date: prettier(_date).date,
                  });
                }}
              />
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <Input
              label="End Date"
              type="text"
              value={formData.end_date}
              icon={<img src={date} alt="ending" />}
              style={{ color: "#165FFC" }}
              readOnly
            />
            <div className={styles.picker__wrapper}>
              <DatePicker
                placeholder=""
                inputReadOnly
                bordered={false}
                value=""
                onChange={(_date) => {
                  setFormData({
                    ...formData,
                    end_date: prettier(_date).date,
                  });
                }}
              />
            </div>
          </div>
        </div> */}
        <motion.div
          // layout
          className={`${styles.recents} ${show ? styles.show : ""}`}
        >
          <div className={styles.title}>
            <img src={recentlyViewed} alt="recently-viewed" />
            <span onClick={() => setShow(!show)}>
              {!show ? "Recently Viewed Events" : "Close"}
            </span>
          </div>
          <AnimatePresence>
            {show && (
              <motion.div
                initial={{ opacity: 0, height: 0, width: "100%" }}
                animate={{ opacity: 1, height: "200px" }}
                exit={{ opacity: 0, height: 0 }}
              >
                <RecentlyViewed />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
        <div className={styles.searchBtn_mob} onClick={updateLocation}>
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            whileTap={{ scale: 0.9 }}
            src={CheckCircleIcon}
            alt="search"
          />
        </div>

        {/* <RangeSlider formData={formData} setFormData={setFormData} /> */}
        {/* <div className={styles.trending}>
          <div className={styles.heading}>
            <span>Trending</span>
            <img src={trending} alt="trending" />
          </div>
          <div className={styles.tags}>
            {data.map((item, index) => {
              return (
                <span className={styles.tag} key={index}>
                  {item}
                </span>
              );
            })}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Form;
